import {
  fontSizeList,
  colorList,
  borderWidthList,
  borderRadiusList,
  lineWidthList,
  store,
  langList,
  fontFamilyList as fontFamilyListZh,
  borderDasharrayList as borderDasharrayListZh,
  lineStyleList as lineStyleListZh,
  rootLineKeepSameInCurveList as rootLineKeepSameInCurveListZh,
  backgroundRepeatList as backgroundRepeatListZh,
  backgroundPositionList as backgroundPositionListZh,
  shortcutKeyList as shortcutKeyListZh,
  shapeList as shapeListZh,
  sidebarTriggerList as sidebarTriggerListZh,
  backgroundSizeList as backgroundSizeListZh,
  downTypeList as downTypeListZh,
  shapeListMap as shapeListMapZh,
  lineStyleMap as lineStyleMapZh,
  numberTypeList as numberTypeListZh,
  numberLevelList as numberLevelListZh,
  linearGradientDirList as linearGradientDirListZh
} from './zh';
import {
  fontFamilyList as fontFamilyListEn,
  borderDasharrayList as borderDasharrayListEn,
  lineStyleList as lineStyleListEn,
  rootLineKeepSameInCurveList as rootLineKeepSameInCurveListEn,
  backgroundRepeatList as backgroundRepeatListEn,
  backgroundPositionList as backgroundPositionListEn,
  shortcutKeyList as shortcutKeyListEn,
  shapeList as shapeListEn,
  sidebarTriggerList as sidebarTriggerListEn,
  backgroundSizeList as backgroundSizeListEn,
  downTypeList as downTypeListEn,
  numberTypeList as numberTypeListEn,
  numberLevelList as numberLevelListEn,
  linearGradientDirList as linearGradientDirListEn
} from './en';
import {
  fontFamilyList as fontFamilyListZhtw,
  borderDasharrayList as borderDasharrayListZhtw,
  lineStyleList as lineStyleListZhtw,
  rootLineKeepSameInCurveList as rootLineKeepSameInCurveListZhtw,
  backgroundRepeatList as backgroundRepeatListZhtw,
  backgroundPositionList as backgroundPositionListZhtw,
  shortcutKeyList as shortcutKeyListZhtw,
  shapeList as shapeListZhtw,
  sidebarTriggerList as sidebarTriggerListZhtw,
  backgroundSizeList as backgroundSizeListZhtw,
  downTypeList as downTypeListZhtw,
  numberTypeList as numberTypeListZhtw,
  numberLevelList as numberLevelListZhtw,
  linearGradientDirList as linearGradientDirListZhtw
} from './zhtw';

const fontFamilyList = {
  zh: fontFamilyListZh,
  en: fontFamilyListEn,
  zhtw: fontFamilyListZhtw
};

const borderDasharrayList = {
  zh: borderDasharrayListZh,
  en: borderDasharrayListEn,
  zhtw: borderDasharrayListZhtw
};

const lineStyleList = {
  zh: lineStyleListZh,
  en: lineStyleListEn,
  zhtw: lineStyleListZhtw
};

const lineStyleMap = {
  zh: lineStyleMapZh,
  en: lineStyleMapZh,
  zhtw: lineStyleMapZh
};

const rootLineKeepSameInCurveList = {
  zh: rootLineKeepSameInCurveListZh,
  en: rootLineKeepSameInCurveListEn,
  zhtw: rootLineKeepSameInCurveListZhtw
};

const backgroundRepeatList = {
  zh: backgroundRepeatListZh,
  en: backgroundRepeatListEn,
  zhtw: backgroundRepeatListZhtw
};

const backgroundPositionList = {
  zh: backgroundPositionListZh,
  en: backgroundPositionListEn,
  zhtw: backgroundPositionListZhtw
};

const backgroundSizeList = {
  zh: backgroundSizeListZh,
  en: backgroundSizeListEn,
  zhtw: backgroundSizeListZhtw
};

const shortcutKeyList = {
  zh: shortcutKeyListZh,
  en: shortcutKeyListEn,
  zhtw: shortcutKeyListZhtw
};

const shapeList = {
  zh: shapeListZh,
  en: shapeListEn,
  zhtw: shapeListZhtw
};

const shapeListMap = {
  zh: shapeListMapZh,
  en: shapeListMapZh,
  zhtw: shapeListMapZh
};

const sidebarTriggerList = {
  zh: sidebarTriggerListZh,
  en: sidebarTriggerListEn,
  zhtw: sidebarTriggerListZhtw
};

const downTypeList = {
  zh: downTypeListZh,
  en: downTypeListEn,
  zhtw: downTypeListZhtw
};

const numberTypeList = {
  zh: numberTypeListZh,
  en: numberTypeListEn,
  zhtw: numberTypeListZhtw
};

const numberLevelList = {
  zh: numberLevelListZh,
  en: numberLevelListEn,
  zhtw: numberLevelListZhtw
};

const linearGradientDirList = {
  zh: linearGradientDirListZh,
  en: linearGradientDirListEn,
  zhtw: linearGradientDirListZhtw
};

export {
  fontSizeList,
  borderWidthList,
  borderRadiusList,
  lineWidthList,
  store,
  colorList,
  langList,
  fontFamilyList,
  borderDasharrayList,
  lineStyleList,
  lineStyleMap,
  rootLineKeepSameInCurveList,
  backgroundRepeatList,
  backgroundPositionList,
  backgroundSizeList,
  shortcutKeyList,
  shapeList,
  shapeListMap,
  sidebarTriggerList,
  downTypeList,
  numberTypeList,
  numberLevelList,
  linearGradientDirList
};
